import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { cn } from '../lib/utils.js';
export function Collapsible({ expanded, onToggle, label, header, children, headerClassName, }) {
    return (_jsxs(_Fragment, { children: [_jsxs("div", { role: "button", tabIndex: 0, "aria-expanded": expanded, "aria-label": label, onClick: () => onToggle?.(), onKeyDown: (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onToggle?.();
                    }
                }, className: cn('-mx-1.5 flex cursor-pointer select-none items-center gap-2 rounded-row px-1.5 py-1 transition-colors duration-[120ms] hover:bg-surface-muted focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent', headerClassName), children: [_jsx(CollapsibleChevron, { collapsed: !expanded }), header] }), expanded ? children : null] }));
}
/** The chevron that rotates to point right when its section is collapsed. */
function CollapsibleChevron({ collapsed }) {
    return (_jsx("span", { className: cn('grid h-4 w-4 flex-shrink-0 place-items-center text-ink-4 transition-transform duration-150 ease-in-out', collapsed && '-rotate-90'), "aria-hidden": "true", children: _jsx("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", children: _jsx("path", { d: "M6 9l6 6 6-6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }) }));
}
/**
 * Tracks which section keys are collapsed. Default is everything expanded (empty set) — so a
 * freshly-rendered accordion shows all its content, and Collapse-all is an explicit action.
 */
export function useCollapsibleSections() {
    const [collapsed, setCollapsed] = useState(new Set());
    return {
        isCollapsed: (key) => collapsed.has(key),
        toggle: (key) => setCollapsed((prev) => {
            const next = new Set(prev);
            if (next.has(key))
                next.delete(key);
            else
                next.add(key);
            return next;
        }),
        collapse: (keys) => setCollapsed(new Set(keys)),
        expandAll: () => setCollapsed(new Set()),
    };
}
//# sourceMappingURL=collapsible.js.map